import React, { forwardRef } from 'react';
const InputElement = forwardRef(({ id, className, type, style, value, defaultValue, placeholder, isEnterPrevent = false, textarea = false, isDisable = false, min, tabIndex, onSubmit, onChange, onKeyDown, onFocus, onBlur, }, ref) => {
    const onKeyUpdateInput = (e) => {
        e.stopPropagation();
        if (isEnterPrevent) {
            if ((e.key === 'Space' || e.key === 'Enter' || e.key === 'NumpadEnter') &&
                !e.shiftKey) {
                e.preventDefault();
                onSubmit && onSubmit();
                return;
            }
        }
        if (onKeyDown) {
            // @ts-ignore
            onKeyDown(e.target?.value);
        }
    };
    const updateInputValue = (e) => {
        const { value } = e.target;
        onChange && onChange(value);
    };
    return textarea ? (React.createElement("textarea", { ref: ref, id: id, className: className, value: value, defaultValue: defaultValue, placeholder: placeholder, style: style, disabled: isDisable, spellCheck: false, onKeyDown: onKeyUpdateInput, onChange: updateInputValue, onFocus: onFocus, onBlur: onBlur, readOnly: isDisable })) : (React.createElement("input", { ref: ref, id: id, className: className, type: type, value: value, defaultValue: defaultValue, placeholder: placeholder, style: style, disabled: isDisable, spellCheck: false, onKeyUp: onKeyUpdateInput, onChange: onChange && updateInputValue, onFocus: onFocus, onBlur: onBlur, min: min, tabIndex: tabIndex, readOnly: isDisable }));
});
export default InputElement;
